module.exports = __webpack_public_path__ + "img/muwahib_logo.56aafcbc.svg";